export default {
  getDelivery: (state) => state.delivery,
};
